<template>
  <div class="contacts_block">
    <router-link class="response-vacancy-title" :to="{path: `/vacancies/${vacancy.id}`}">
      {{ vacancy.name }}
    </router-link>
    <div class="info_block">
      <span class="archive-label" v-if="!vacancy.is_active && !vacancy.is_deleted">
        {{$tr('vacancies.archiveLabel')}}
      </span>
      <span class="remove-label" v-if="vacancy.is_deleted">
        {{$tr('vacancies.removeLabel')}}
      </span>
      <a class="email_color" :href="'mailto:' + candidate.email">{{ candidate.email }}</a>
      <span>{{ candidate.phone }}</span>
      <span class="nexxt-img" v-if="is_nexxt">
        <img src="/static/images/elements/nexxt-recruiter.png" alt="nexxt">
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'process-response-blocks-block-contacts-default',

    props: {
      candidate: {
        type: Object,
        default: {}
      },
      vacancy: {
        type: Object,
        default: {}
      },
      response: {
        type: Object,
        default: {}
      }
    },

    computed: {
      is_nexxt() {
        if (!this.response || !this.response.source) {
          return false;
        }

        return this.response.source.name && this.response.source.name.toLowerCase() === 'nexxt'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/styles/colors.scss";
  @import "@/styles/components/response/blocks/BlockContacts.scss";

  .remove-label {
    margin-left: -24px;
    line-height: 20px;
    bottom: 4px;
    padding: 0 3px;
    height: 20px;
  }
</style>
